// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"96069980","421":"83571726"}[chunkId] + ".chunk.css";
};